import { all } from 'redux-saga/effects';
import { Saga } from 'redux-saga';
import { shop } from './shop';
import { pricing } from './pricing';
import { analytics } from './analytics';
import { trustpilot } from './trustpilot';
import { businessModule } from './businessModule';

const sagas: Saga[] = [
  shop, pricing, analytics, trustpilot, businessModule,
];

export default function* allSagas() {
  yield all([...sagas].map((saga) => saga()));
}
